import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {CommService} from '../../../services/comm-service';
import {switchMap, debounceTime, tap, finalize, startWith, map, catchError, distinctUntilChanged, filter} from 'rxjs/operators';
import {Observable, empty} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SurveyDTO } from 'src/DTOs/PatientProcedures/Models/SurveyDTO';
import { environment } from 'src/environments/environment';
//import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-survey-autocomplete',
  templateUrl: './survey-autocomplete.component.html',
  styleUrls: ['./survey-autocomplete.component.css']
})
export class SurveyAutocompleteComponent implements OnInit {
  @Input() public selectedSurvey: SurveyDTO = null;  
  @Output() surveyChanged: EventEmitter<SurveyDTO> = new EventEmitter<SurveyDTO>();

  filteredSurveys: SurveyDTO[] = [];
  surveysForm: FormGroup;
  isProcessing = false;
 
  constructor(   
    private fb: FormBuilder,
    private commService: CommService,
    private translate: TranslateService) 
  { 

  }

  ngOnInit() {
    this.surveysForm = this.fb.group({
      surveyInput: null
    });

    if (environment.debug_mode) {     
      console.log("selectedSurvey:" + JSON.stringify(this.selectedSurvey));
    } 

    if(this.selectedSurvey != null)
    {
      console.log("set selected survey to input.");
      this.displayFn(this.selectedSurvey);

      this.surveysForm
        .get('surveyInput')
        .setValue(this.selectedSurvey);
        
    }

    this.surveysForm
      .get('surveyInput')
      .valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => this.isProcessing = true),
        filter(value=>value? true: false),
        switchMap(value => this.commService.search({name: value}, 1)
        .pipe(catchError(() => {return empty()}))
        .pipe(          
          finalize(() => this.isProcessing = false)
          )        
        )        
      )
      .subscribe(surveys => {
         console.log("filtered surveys")
         this.filteredSurveys = surveys;
      });
  }

  displayFn(survey: SurveyDTO) {
    console.log("displayFn:"+ JSON.stringify(survey));
    
    if (survey) { 
      this.selectedSurvey = survey;
      return survey.surveyTitle +" | ID:" + survey.surveyId; 
    }
    console.log("displayFn selected:"+ JSON.stringify(this.selectedSurvey));    
  }

  surveyChangedFn($event) {
    console.log("surveyChangedFn:"+ JSON.stringify($event.option.value));
    this.surveyChanged.emit($event.option.value);
  }
   
}
